var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'tw-border-b tw-py-4': _vm.border,
  }},[_c('dt',{staticClass:"tw-text-gray-500"},[_vm._t("title")],2),_vm._v(" "),_c('dd',{staticClass:"tw-mt-1 tw-font-medium"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }